import React from "react";
import { fontSizes } from "../../utils/constants";
import IncrDecrInput from "./IncrDecrInput.jsx";

class SetFontSizeComponent extends React.Component {
    constructor(props) {
        super(props);
        let index = this.findClosestFontSizeIndex( props.Dyn.preferences.getFontSize().toString())
        this.state = {
            fontSize: fontSizes[index].value
        };
    }

    findClosestFontSizeIndex = ( label ) => {
        let indexEqual = fontSizes.findIndex( ( obj ) => obj.label === label ),
            indexGreater = fontSizes.findIndex( ( obj ) => obj.label > label );
        return (indexEqual >= 0) ? indexEqual : (indexGreater >= 0) ? indexGreater : fontSizes.length-1;
    };

    setFontSize = (m) => {
        let Dyn = this.props.Dyn;
        Dyn.preferences.setFontSizeMultiplier(m);
    };

    updateFontSize = () => {
        let index = this.findClosestFontSizeIndex( this.props.Dyn.preferences.getFontSize().toString())
        this.setState({
            fontSize: fontSizes[index].value,
        });
    };

    componentDidMount = () => {
        let { Dyn } = this.props;
        Dyn.addSubcribersToClean(
            Dyn.mediator.subscribe("pref:newFontSize", () => {
                console.log(this.props.Dyn.preferences.getFontSize());
                this.updateFontSize();
            })
        );
    };

    render() {
        return (
            <IncrDecrInput
                label={"Font Size"}
                onChange={(fontSize) =>
                    this.setState({ fontSize }, () =>
                        this.setFontSize(fontSize)
                    )
                }
                getLoc={this.props.getLoc}
                value={this.state.fontSize}
                options={fontSizes}
                className={
                    "tde-mb-3" + this.props.isFromContextMenu
                        ? null
                        : this.props.reduceCaseCardWidth
                        ? " tde-fill"
                        : " tde-col-8"
                }
            ></IncrDecrInput>
        );
    }
}

export default SetFontSizeComponent;
